import { invoiceStore, useStores } from '../../stores';
import Receipt from '../../pages/Receipt/Receipt';
import React, { useState } from 'react';

const ReceiptContainer = () => {
	const [addNewReceipt, setAddNewReceipt] = useState(false);
	const [editReceiptModal, setEditReceiptModal] = useState(false);
	const [viewReceiptModal, setViewReceiptModal] = useState(false);
	const [customerMenu, setReceiptMenu] = useState(false);

	const { userStore } = useStores();

	const logout = () => {
		userStore.setLoggedIn(false);
	};

	const goToNewReceipt = () => {
		setAddNewReceipt(true);
	};

	const goToEditReceipt = () => {
		setEditReceiptModal(true);
		setViewReceiptModal(false);
	};

	const goToViewReceipt = () => {
		setViewReceiptModal(true);
		setEditReceiptModal(false);
	};

	const closeModal = () => {
		setAddNewReceipt(false);
		setEditReceiptModal(false);
		setViewReceiptModal(false);
	};

	const showReceiptMenu = () => {
		setReceiptMenu(!customerMenu);
	};

	return (
		<div>
			<Receipt
				logout={logout}
				receiptDetails={invoiceStore.invoices}
				goToNewReceipt={goToNewReceipt}
				addNewReceipt={addNewReceipt}
				closeModal={closeModal}
				goToViewReceipt={goToViewReceipt}
				viewReceiptModal={viewReceiptModal}
			/>
		</div>
	);
};

export default ReceiptContainer;
